import { ResourceOptions } from 'react-admin';
import { FaBoxOpen } from 'react-icons/fa';
import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.blindBoxManualDistribution;
export const icon = FaBoxOpen;
export const options: ResourceOptions = {
  label: 'module.blindBox.manualDistribution',
};
